module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMCA2NEMyOTkuOSAxMjggMTI4IDI5OS45IDEyOCA1MTJzMTcxLjkgMzg0IDM4NCAzODQgMzg0LTE3MS45IDM4NC0zODRTNzI0LjEgMTI4IDUxMiAxMjh6IG0xMjggMjI0YTMyIDMyIDAgMCAxIDMyIDMydjI1NmEzMiAzMiAwIDAgMS0zMiAzMmgtMjU2YTMyIDMyIDAgMCAxLTMyLTMydi0yNTZhMzIgMzIgMCAwIDEgMzItMzJoMjU2eiIgZmlsbD0iIzAiIHAtaWQ9IjE2OTgiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Stop-outlined.svg
// module id = Rut3
// module chunks = 74